import { render, staticRenderFns } from "./FundCitationDelete.vue?vue&type=template&id=5bdf907e"
import script from "./FundCitationDelete.vue?vue&type=script&lang=js"
export * from "./FundCitationDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports